import { WealthSurvey } from '../components/landing';
import { Toaster } from '../components/ui/sonner';

export default function SurveyPage() {
  return (
    <div
      className="min-h-screen bg-[#0A0A0A] flex flex-col"
      data-testid="survey-page"
    >
      <Toaster position="top-center" richColors />

      {/* Minimal header */}
      <header className="border-b border-white/5 bg-[#0A0A0A]/80 backdrop-blur-md">
        <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between">
          <a
            href="/"
            className="flex items-center gap-3 group"
            data-testid="header-home-link"
          >
            <div className="w-9 h-9 rounded-lg bg-[#D4AF37] text-[#0A0A0A] flex items-center justify-center font-cormorant font-bold text-lg">
              R
            </div>
            <div className="hidden sm:block">
              <p className="text-white font-cormorant text-lg leading-tight">
                The Reset
              </p>
              <p className="text-zinc-500 font-manrope text-[10px] uppercase tracking-widest">
                July 23–26, 2026
              </p>
            </div>
          </a>
          <a
            href="/"
            className="text-zinc-400 hover:text-[#D4AF37] font-manrope text-sm transition-colors"
            data-testid="back-to-landing-link"
          >
            ← Back to home
          </a>
        </div>
      </header>

      {/* Survey */}
      <main className="flex-1">
        <WealthSurvey />
      </main>

      {/* Footer */}
      <footer className="border-t border-white/5 py-8 px-6">
        <div className="max-w-5xl mx-auto text-center">
          <p className="text-zinc-600 font-manrope text-xs">
            The Reset 2026 · Panama City, Panama · The Westin Playa Bonita
          </p>
        </div>
      </footer>
    </div>
  );
}
